"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.nsXmlns = void 0;
var nsXmlns = 'http://www.w3.org/2000/xmlns/';
exports.nsXmlns = nsXmlns;